module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"#fff\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"35px\" height=\"18.7px\" viewBox=\"0 0 35 18.7\" xml:space=\"preserve\"><defs></defs> <path d=\"M17.6,18.7c-0.3,0-0.5-0.1-0.8-0.3L0.3,1.8c-0.4-0.4-0.4-1.1,0-1.5s1.1-0.4,1.5,0l15.8,15.8L33.2,0.5\n                                    c0.4-0.4,1.1-0.4,1.5,0c0.4,0.4,0.4,1.1,0,1.5L18.3,18.3C18.1,18.6,17.9,18.7,17.6,18.7z\" class=\"fillWhite\"></path></svg>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/assets/icons/icon-arrow-bottom.svg
// module id = ka2k
// module chunks = 1